/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefApiKeyData } from '../../models/api-def-api-key-data';

export interface OrganizationsGetApiKey$Params {
  organizationId: string;
  apiKeyId: string;
}

export function organizationsGetApiKey(http: HttpClient, rootUrl: string, params: OrganizationsGetApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefApiKeyData>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetApiKey.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('apiKeyId', params.apiKeyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefApiKeyData>;
    })
  );
}

organizationsGetApiKey.PATH = '/organizations/{organizationId}/api-keys/{apiKeyId}';
